import {
  useDropDownItemsStore,
  useFilterSettingsStore,
} from 'src/StoreDataProvider';
import { ISOCode } from 'src/components/molecules/WorldMap/worldMap.types';

export interface SelectedRegionHooks {
  actions: {
    getISOCodesBySelectedRegions: () => ISOCode[];
  };
}

const useSelectedRegionHooks = (): SelectedRegionHooks => {
  const dropwnItemsStore = useDropDownItemsStore();
  const filterSettingsStore = useFilterSettingsStore();

  const getISOCodesBySelectedRegions = (): ISOCode[] => {
    const isoCodes: ISOCode[] = [];
    dropwnItemsStore.region.forEach(value => {
      if (filterSettingsStore.region.includes(value.key)) {
        isoCodes.push(...value.isoCodes);
      }
    });
    return isoCodes;
  };
  return { actions: { getISOCodesBySelectedRegions } };
};

export default useSelectedRegionHooks;
